import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Title from "./Title";

const courseData = {
    LittleSwim: {
        accent: "blue",
        schedule: [
            { category: "Děti od 1 roku do 3 let", pool: "AD Landek, Petřkovice", day: "Úterý", times: ["16:30", "17:00", "17:30"] },
            { category: "Děti od 1 roku do 3 let", pool: "AD Landek, Petřkovice", day: "Středa", times: ["09:00", "09:30", "10:00"] },
            { category: "Děti od 6 měsíců do 3 let", pool: "Bazén Mexiko, Ostrava", day: "Čtvrtek", times: ["14:00 – 17:00"] },
            { category: "Děti od 1 roku do 3 let", pool: "Čapkárna, Ostrava", day: "Pátek", times: ["10:00 – 11:30"] },
            { category: "Děti od 3 let", pool: "Čapkárna, Ostrava", day: "Pondělí", times: ["15:30", "16:30", "17:30"] },
            { category: "Děti od 3 let", pool: "Čapkárna, Ostrava", day: "Středa", times: ["15:30", "16:30", "17:30"] },
        ],
    },
    LittleNinjas: {
        accent: "yellow",
        schedule: [
            { category: "Děti od 2 roků do 3 let", pool: "AD Landek, Petřkovice", day: "Pondělí", times: ["09:00"] },
            { category: "Děti od 1 roku do 2 let", pool: "AD Landek, Petřkovice", day: "Pondělí", times: ["09:50"] },
            { category: "Děti od 6 měsíců do 1 roku", pool: "AD Landek, Petřkovice", day: "Pondělí", times: ["10:45"] },
        ],
    },
};

export default function CourseSchedule() {
    const { t } = useTranslation();
    const [active, setActive] = useState("LittleSwim");
    const { accent, schedule } = courseData[active];

    // překlady
    const subtitle = t(
        active === "LittleSwim" ? "scheduleSwimSubtitle" : "scheduleNinjasSubtitle"
    );
    const tabLabels = {
        LittleSwim: t("scheduleSwitch1", "Plavání"),
        LittleNinjas: t("scheduleSwitch2", "Cvičení"),
    };

    const tabClass = (key) => {
        const base = "cursor-pointer px-4 py-2 rounded-full font-oswald transition";
        if (key === active) {
            if (accent === "blue")   return base + " bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300";
            if (accent === "yellow") return base + " bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-300";
        }
        return base + " text-gray-400 hover:text-gray-700 dark:text-gray-500 dark:hover:text-gray-300";
    };

    const headerBg = {
        blue:   "bg-blue-200 dark:bg-blue-800",
        yellow: "bg-yellow-200 dark:bg-yellow-800",
    }[accent];

    const titleColor = {
        blue:   "text-blue-900 dark:text-blue-300",
        yellow: "text-yellow-600 dark:text-yellow-300",
    }[accent];

    return (
        <section id="rozvrh" className="container mx-auto px-6 py-12 dark:bg-gray-900 dark:text-white select-none">
            <Title
                title={t("scheduleTitle", "Rozvrh lekcí")}
                titleColor={titleColor}
                from={accent === "blue" ? "from-sky-200" : "from-yellow-100"}
                to="to-white"
            />

            {/* přepínače */}
            <div className="flex justify-center gap-4 mt-6 mb-10">
                {Object.keys(courseData).map((key) => (
                    <div
                        key={key}
                        className={tabClass(key)}
                        onClick={() => setActive(key)}
                    >
                        {tabLabels[key]}
                    </div>
                ))}
            </div>

            {/* desktopová tabulka */}
            <div className="hidden md:block bg-white dark:bg-gray-800 rounded-lg shadow-lg p-6">
                <h2 className={`font-gluten text-2xl mb-4 text-center ${titleColor}`}>
                    {subtitle}
                </h2>
                <div className="overflow-x-auto">
                    <table className="min-w-full font-varela text-gray-900 dark:text-gray-200">
                        <thead className={`${headerBg} uppercase text-sm`}>
                        <tr>
                            <th className="py-2 px-4 text-left">{t("tableCol1", "Věková kategorie")}</th>
                            <th className="py-2 px-4 text-left">{t("tableCol2", "Bazén")}</th>
                            <th className="py-2 px-4 text-left">{t("tableCol3", "Den")}</th>
                            <th className="py-2 px-4 text-left">{t("tableCol4", "Čas")}</th>
                        </tr>
                        </thead>
                        <tbody>
                        {schedule.map((row, i) => (
                            <tr
                                key={i}
                                className={`hover:bg-gray-100 dark:hover:bg-gray-700 ${
                                    i % 2 === 0
                                        ? "bg-gray-50 dark:bg-gray-700"
                                        : "bg-white dark:bg-gray-800"
                                }`}
                            >
                                <td className="py-2 px-4">{row.category}</td>
                                <td className="py-2 px-4">{row.pool}</td>
                                <td className="py-2 px-4">{row.day}</td>
                                <td className="py-2 px-4">{row.times.join(", ")}</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Mobily: jedna karta na řádek */}
            <div className="md:hidden space-y-6">
                {schedule.map((row, i) => (
                    <div
                        key={i}
                        className={`
        bg-white dark:bg-gray-800 rounded-lg shadow-lg
        border-l-4 ${accent === 'blue' ? 'border-blue-500' : 'border-yellow-500'}
      `}
                    >
                        {/* Nadpis s kategorií */}
                        <div className={`
        rounded-t-lg p-3
        ${accent === 'blue' ? 'bg-blue-100 text-blue-800' : 'bg-yellow-100 text-yellow-800'}
        dark:${accent === 'blue' ? 'bg-blue-900 text-blue-300' : 'bg-yellow-900 text-yellow-500'}
      `}>
                            <h3 className="font-oswald text-lg">{row.category}</h3>
                        </div>

                        {/* Detailní popisky */}
                        <div className="p-6 space-y-2 font-varela text-gray-800 dark:text-gray-200">
                            <p>
                                <strong>{t("tableCol1")}:</strong> {row.category}
                            </p>
                            <p>
                                <strong>{t("tableCol2")}:</strong> {row.pool}
                            </p>
                            <p>
                                <strong>{t("tableCol3")}:</strong> {row.day}
                            </p>
                            <p>
                                <strong>{t("tableCol4")}:</strong> {row.times.join(", ")}
                            </p>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
}
